import React, { useState } from 'react';
import LoginForm from './LoginForm';
import RegisterForm from './RegisterForm';

const Auth = () => {
    const [isLogin, setIsLogin] = useState(true);

    return (
        <div className="w-full min-h-[85vh] flex items-center justify-center px-4 py-8 bg-gray-50/50">
            <div className="w-full max-w-md flex justify-center">
                {isLogin ? (
                    <LoginForm onToggleAuth={() => setIsLogin(false)} />
                ) : (
                    <RegisterForm onToggleAuth={() => setIsLogin(true)} />
                )}
            </div>
        </div>
    );
};

export default Auth;